import { EnvironmentTag } from "@coworker/app/src/components/EnvironmentTag";
import {
  useGivenName,
  useMyStore,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { Trans } from "@coworker/locales";
import { FixaWindow } from "@coworker/reusable/helpers/devices";
import { useState } from "react";
import { ProductQualityError } from "../../../shared/components/ProductQualityError/productQualityError";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { DiscoverNow } from "../DiscoverNow/DiscoverNow";
import { QuickActions } from "../QuickActions/QuickActions";
import { TasksPreview } from "../TasksPreview/TasksPreview";
import styles from "./home-page.module.css";

export const HomePage = () => {
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const store = useMyStore();
  const firstname = useGivenName();

  return (
    <div className={styles["home-outer-container"]}>
      <div className={styles["home-container"]}>
        <div className={styles["vertical-center"]}>
          <FixaText textStyle="Heading.L" tagName="h2">
            {<Trans>hejString</Trans>} {firstname},
            {store?.storeId && store?.name && (
              <FixaText tagName="p" textStyle="Body.M">
                {store.storeId} - {store.name}
              </FixaText>
            )}
          </FixaText>
          <EnvironmentTag />
        </div>
        <div className={styles["quick-actions-container"]}>
          <QuickActions
            id="quickActionsHome"
            setOpenProductQualityErrorModal={setOpenErrorModal}
          />
        </div>
        <ProductQualityError
          openProductQualityErrorModal={openErrorModal}
          onClose={setOpenErrorModal}
        />
        {(window as FixaWindow).enableDiscoverNow && <DiscoverNow />}
        <TasksPreview />
      </div>
    </div>
  );
};
